// extracted by mini-css-extract-plugin
export default {"contents":"styles_contents__JzIFD","fadeIn":"styles_fadeIn__eobj0"};